// 2GY Water Solutions — theme.js

document.addEventListener('DOMContentLoaded', function () {
  /* Mobile nav toggle */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      siteNav.classList.toggle('is-open');
      var expanded = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!expanded));
    });
  }

  /* Gauge needle sweep on scroll into view */
  var gauges = document.querySelectorAll('[data-gauge]');
  if ('IntersectionObserver' in window && gauges.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    gauges.forEach(function (g) { observer.observe(g); });
  } else {
    gauges.forEach(function (g) { g.classList.add('is-inview'); });
  }

  /* AJAX add to cart */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: form.querySelector('[name="id"]').value,
            quantity: parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10)
          }]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Could not add to cart');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          button.textContent = 'Added ✓';
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1400);
        })
        .catch(function () {
          button.textContent = 'Try again';
          button.disabled = false;
        });
    });
  });

  /* Cart page: quantity update */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: input.value })
      }).then(function () { window.location.reload(); });
    });
  });
});
